import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Mic } from '@material-ui/icons';
import styled from 'styled-components';

import Icon from '@material-ui/core/Icon';

// Components
import Tooltip from '../tooltip';
import CustomMenu from '../menu';

// Styles
import { colors, radius } from '../../styles/variables';
import { Flex, Text } from '../../styles/common';
import { whiteAlpha } from '../../styles/utils';

const TooltipText = styled(Text)`
  &:not(:last-child) {
    padding-bottom: 0;
  }
`;

const useStyles = () => ({
  root: {
    width: '28rem',
    // backgroundColor: 'transparent',
    backgroundColor: colors.blue.navy,
    cursor: 'pointer',
    '& .MuiCardContent-root:last-child': {
      paddingBottom: '1.5rem',
    },
  },
  gradientWrapper: {
    width: '100%',
    borderRadius: `${radius.default} ${radius.default} 0 0`,
    position: 'relative',
    height: '15.7rem',
  },
  gradientText: {
    width: '100%',
    // height: '16.2rem',
    fontSize: '3.2rem',
    fontWeight: '300',
    color: colors.white,
    boxSizing: 'border-box',
  },
  media: {
    height: '15.7rem',
    // borderRadius: radius.default,
    position: 'relative',
  },
  cardInfo: {
    borderRadius: `0 0 ${radius.default} ${radius.default}`,
    padding: '1.5rem',
    margin: '0',
    backgroundColor: colors.blue.navy,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  taskType: {
    color: colors.white,
    fontSize: '1.4rem',
    padding: '0',
    marginBottom: '.8rem',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '15rem',
  },
  userName: {
    color: whiteAlpha(0.7),
    fontSize: '1rem',
    padding: 0,
  },
  taskStatus: {
    // color: (props)=> props.taskStatus == 'Inqueue' && 'blue' ||  props.taskStatus == 'In Progress' && 'yellow' || 'green' ,
    fontSize: '1.4rem',
    padding: '0',
    marginBottom: '.8rem',
    textAlign: 'right',
  },
  taskDueDate: {
    color: whiteAlpha(0.7),
    fontSize: '1rem',
    padding: 0,
    textAlign: 'right',
  },
  micIcon: {
    fontSize: '2rem',
    color: 'rgba(255, 255, 255, 0.7)',
  },
});

const CardStyled = styled(Card)`
  position: relative;

  .hover-block {
    position: absolute;
    top: -100%;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    background-color: #0c1d33;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    transition: all 0.3s ease-out;
  }
  &:hover .hover-block {
    top: 0;
    opacity: 1;
  }

  .time-spent-title {
    color: rgba(255, 255, 255, 0.9);
    font-weight: 300;
    font-size: 1.4rem;
    padding: 0;
    margin-bottom: 1rem;
  }
  .time-spent-value {
    color: rgba(255, 255, 255, 0.9);
    font-weight: 300;
    font-size: 3.4rem;
    padding: 0;
    margin-bottom: 1rem;
  }

  // .text-overlay-block{
  //   position: absolute;
  //   top: 0;
  //   left:0;
  //   height: 100%;
  //   width: 100%;
  //   opacity: 1;
  //   background: linear-gradient(rgb(0,0,0),rgba(0,0,0,0.72));
  //   display: flex;
  //   transition: all 0.3s ease-out;
  //   color: #FFF;
  //   width: 100%;
  //   font-size: 3.2rem;
  //   word-break: break-all;
  //   font-weight: 300;
  //   padding: 0.8rem 1.2rem;
  //   & > div{
  //     overflow: hidden;
  //     display: -webkit-box;
  //     -webkit-line-clamp: 3;
  //     -webkit-box-orient: vertical;
  //     word-break: break-word;
  //     height: 12.2rem;
  //   }
  // }
  // &:hover .text-overlay-block{
  //   top: -100%;
  //   opacity: 0;
  // }

  .iframe-image-block {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: pointer;
    overflow: hidden;
    background: #000;
    opacity: 0;
    &:hover {
      opacity: 1;
    }
    .hover-pointer {
      position: absolute;
      width: 1px;
      height: 100%;
      top: 0;
      background: #fff;
      pointer-events: none;
      z-index: 1;
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
    }
  }

  .top-action-holder {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
    color: #fff;
    font-size: 2rem;
    padding: 1rem 1rem;
    opacity: 0;
    background: rgba(0, 0, 0, 0);
    background: radial-gradient(at 100% 0%, #00000063 38%, #00000000 75%);
    .top-action {
      border: 1px solid #fff;
      border-radius: 9rem;
      background: rgba(0, 0, 0, 0);
      transition: all 0.2s ease-out;
      padding: 0.2rem 1.2rem;
      display: inline-block;
      margin-right: 1rem;
      &:hover {
        border: 1px solid #559eff;
        background: #559eff;
      }
    }
  }

  &:hover .top-action-holder {
    opacity: 1;
  }
`;
const GradientTextStyled = styled.p`
  word-break: break-word;
  font-weight: 300;
  background: ${props => props.cardTypeColor};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 2rem 1.5rem 0;
  height: 13rem;
  overflow: hidden;
  line-height: 1.13;
`;

const GradientTextStatusStyled = styled(Typography)`
  background: ${props =>
    props.taskStatus == 'In Queue'
      ? 'linear-gradient(to right, #a5ccff, #559eff)'
      : props.taskStatus == 'In Progress'
      ? 'linear-gradient(to right, #e2c00f, #ffa751 100%)'
      : props.taskStatus == 'Expired'
      ? 'linear-gradient(90deg, #FF8D29 0%, #F6462C 100%)'
      : props.taskStatus == 'Pending'
      ? 'linear-gradient(90deg, #A5CCFF 0%, #559EFF 100%)'
      : props.taskStatus == 'Completed'
      ? 'linear-gradient(90deg, #2C86FF 0%, #19D7B2 100%)'
      : 'linear-gradient(to right, #2c86ff, #19d7b2 100%)'};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

// export default function TaskCard(props) {
class TaskCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.menuOptionsRef;
  }

  handleMouseMove = () => {
    if (this._iframeImageBlock) {
      const iframeBlockHeight = this._iframeImageBlock.offsetHeight;
      const iframeOgHeight = 240;
      const ogHeight = this._iframeImage.naturalHeight;
      const { offsetHeight } = this._iframeImage;
      const { offsetWidth } = this._iframeImage;
      const iframeCount = ogHeight / iframeOgHeight;
      const iframeOffsetHeight = offsetHeight / iframeCount;
      const imageChangePoint = offsetWidth / iframeCount;
      const offsetTop = Math.abs(iframeBlockHeight - iframeOffsetHeight) / 2;
      this._hoverPointer.style.left = event.offsetX + 'px';
      const imageNum = parseInt(event.offsetX / imageChangePoint) || 1;
      let imageTop = iframeOffsetHeight * imageNum + offsetTop;
      if (imageTop > offsetHeight) {
        imageTop = offsetHeight + offsetTop - iframeOffsetHeight;
      }
      this._iframeImage.style.top = '-' + imageTop + 'px';
    }
  };

  getUsersProfile = (users, classes) => {
    const userNames = users.map(item => (item.name ? item.name : item));
    const firstElement = userNames.shift(); // remove first element from array and will change the original array

    if (userNames.length >= 1) {
      return (
        <Tooltip
          placement='top'
          title={userNames.map(item => (
            <TooltipText sm>{item}</TooltipText>
          ))}>
          <Flex>
            <Typography
              variant='body2'
              color='textSecondary'
              component='p'
              className={classes.userName}>
              {firstElement}
            </Typography>
            <Typography
              variant='body2'
              color='textSecondary'
              component='p'
              className={classes.userName}
              style={{ marginLeft: '0.5rem' }}>
              {`+${userNames.length}`}
            </Typography>
          </Flex>
        </Tooltip>
      );
    }
    return (
      <Typography
        variant='body2'
        color='textSecondary'
        component='p'
        className={classes.userName}>
        {firstElement}
      </Typography>
    );
  };

  render = () => {
    const {
      cardName,
      userNames,
      cardType,
      previewImageLink,
      onClick,
      taskType,
      taskStatus,
      taskDueDate,
      timeSpent,
      iframeURL,
      classes,
      topAction,
      onActionClick,
      field,
      renderDropdownMenu,
    } = this.props;
    const { isMenuOpen } = this.state;
    return (
      <CardStyled
        className={classes.root}
        onClick={e => {
          if (this.menuOptionsRef && this.menuOptionsRef.contains(e.target)) {
            this.setState({ isMenuOpen: true });
          } else if (isMenuOpen) {
            this.setState({ isMenuOpen: false });
          } else {
            onClick(e);
          }
        }}>
        {cardType !== 'project' ? (
          <CardMedia className={classes.media} image={previewImageLink}>
            {iframeURL && iframeURL !== '' && (
              <div
                onMouseMove={this.handleMouseMove}
                className='iframe-image-block'
                ref={iframeImageBlock => {
                  this._iframeImageBlock = iframeImageBlock;
                }}>
                <div
                  className='hover-pointer'
                  ref={hoverPointer => {
                    this._hoverPointer = hoverPointer;
                  }}
                />
                <img
                  alt={cardName}
                  className='iframe-image'
                  ref={iframeImage => {
                    this._iframeImage = iframeImage;
                  }}
                  src={iframeURL}
                />
              </div>
            )}
            {/* <div className='text-overlay-block'>
							<div>{cardName}
							</div>
						</div> */}
          </CardMedia>
        ) : (
          <div className={classes.gradientWrapper}>
            <GradientTextStyled
              className={classes.gradientText}
              {...this.props}>
              {cardName}
            </GradientTextStyled>
            {timeSpent ? (
              <div className='hover-block'>
                <div style={{ textAlign: 'center' }}>
                  <p className='time-spent-title'>Time Spent</p>
                  <p className='time-spent-value'>{timeSpent}</p>
                </div>
              </div>
            ) : null}
          </div>
        )}
        <CardContent className={classes.cardInfo}>
          <div className='card-info'>
            <Tooltip
              placement='top'
              title={
                taskType?.length > 20 && (
                  <Text sm padding='0'>
                    {taskType}
                  </Text>
                )
              }>
              <Typography
                variant='body1'
                color='textSecondary'
                component='p'
                className={classes.taskType}
                style={{
                  pointerEvents: taskType?.length > 25 ? 'auto' : 'none',
                }}>
                {taskType}
              </Typography>
            </Tooltip>

            {this.getUsersProfile(userNames, classes)}
          </div>
          <div className='card-info'>
            {field === 'shared_assets' ? (
              <>
                <div
                  ref={ref => {
                    this.menuOptionsRef = ref;
                  }}
                  style={{ textAlign: 'right' }}>
                  {renderDropdownMenu()}
                </div>
                <Tooltip title='Access By' hide placement='top' arrow>
                  <Typography
                    variant='body2'
                    color='textSecondary'
                    component='p'
                    className={classes.taskDueDate}>
                    {taskDueDate}
                  </Typography>
                </Tooltip>
              </>
            ) : (
              <>
                <GradientTextStatusStyled
                  taskStatus={taskStatus}
                  variant='body1'
                  color='textSecondary'
                  component='p'
                  className={classes.taskStatus}>
                  {taskStatus}
                </GradientTextStatusStyled>
                <Typography
                  variant='body2'
                  color='textSecondary'
                  component='p'
                  className={classes.taskDueDate}>
                  {taskDueDate}
                </Typography>
              </>
            )}
          </div>
        </CardContent>
      </CardStyled>
    );
  };
}

TaskCard.propTypes = {
  userName: PropTypes.string,
  field: PropTypes.string,
  cardName: PropTypes.string,
  cardType: PropTypes.bool,
  previewImageLink: PropTypes.string,
  onClick: PropTypes.func,
  renderDropdownMenu: PropTypes.func,
  classes: PropTypes.instanceOf(Object),
};

export default withStyles(useStyles)(TaskCard);
